import styled from '@emotion/styled';

export const Container = styled.div`
    width: 100%;
    padding: ${({ theme }) => theme.spacing[4]};
    display: flex;
    flex-direction: column;
    font-family: ${({ theme }) => theme.font.family};
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[4]};
    gap: ${({ theme }) => theme.spacing[4]};
    h2 {
        margin-bottom: 10px;
    }
`;

export const ExpandAllToggle = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: ${({ theme }) => theme.spacing[2]};
`;

export const ExpandAllButton = styled.button`
    background: none;
    border: none;
    color: ${({ theme }) => theme.color.bloodyMary};
    font-size: ${({ theme }) => theme.font.size.small};
    cursor: pointer;
    padding: ${({ theme }) => theme.spacing[1]} ${({ theme }) => theme.spacing[2]};
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[1]};

    &:hover {
        text-decoration: underline;
    }
`;

export const Section = styled.div`
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    overflow: hidden;
`;

export const SectionHeader = styled.div<{ isCollapsed: boolean }>`
    display: flex;
    align-items: center;
    padding: ${({ theme }) => theme.spacing[3]};
    background-color: ${({ theme }) => theme.color.white100};
    cursor: pointer;
    user-select: none;

    &:hover {
        background-color: ${({ theme }) => theme.color.grey100};
    }
`;

export const SectionIcon = styled.span`
    font-size: 20px;
    margin-right: ${({ theme }) => theme.spacing[2]};
`;

export const SectionTitle = styled.span`
    font-weight: ${({ theme }) => theme.font.weight.medium};
    font-size: ${({ theme }) => theme.font.size.normal};
    flex: 1;
`;

export const SectionCount = styled.span`
    color: ${({ theme }) => theme.color.grey500};
    font-size: ${({ theme }) => theme.font.size.small};
    margin-right: ${({ theme }) => theme.spacing[2]};
`;

export const SectionChevron = styled.span<{ isCollapsed: boolean }>`
    transition: transform 0.2s ease;
    transform: ${({ isCollapsed }) => (isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)')};
    font-size: 12px;
    color: ${({ theme }) => theme.color.grey500};
`;

export const SectionContent = styled.div<{ isCollapsed: boolean }>`
    display: ${({ isCollapsed }) => (isCollapsed ? 'none' : 'block')};
    padding: ${({ theme }) => theme.spacing[3]};
    background-color: ${({ theme }) => theme.color.white200};
    border-top: 1px solid ${({ theme }) => theme.color.grey200};
`;

export const Subsection = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing[3]};

    &:last-child {
        margin-bottom: 0;
    }
`;

export const SubsectionTitle = styled.div`
    font-weight: ${({ theme }) => theme.font.weight.medium};
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.grey500};
    margin-bottom: ${({ theme }) => theme.spacing[2]};
    padding-bottom: ${({ theme }) => theme.spacing[1]};
    border-bottom: 1px solid ${({ theme }) => theme.color.grey200};
`;

export const FlagsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const PermissionWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;
export const PermissionText = styled.p`
    font-size: ${({ theme }) => theme.font.size.normal};
`;
export const ButtonWrapper = styled.div`
    width: 40px;
`;
